import React, { useEffect, useState } from "react";
import "./DisplayRecordsPage.css";
import RecordDisplayGrid from "../../components/RecordDisplayGrid/RecordDisplayGrid";
import CompletedRecordDisplayGrid from "../../components/CompletedRecordDisplayGrid/CompletedRecordDisplayGrid";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  completeJobsAPI,
  fetchRecords,
  sendOneKeyValidation,
  oneKeyStatus,
  clearRecords,
  retrieveColumnsByJobId,
  validateAddressApi,
} from "./displayRecordsSlice";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const DisplayRecordsPage = ({ IsInProgress }) => {
  // Authorization is now handled at the route level in ChiesiRoutes
  
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user_token = useSelector((state) => state.login.token);

  // Reusable confirmation button component
  const ConfirmationButton = ({ onClick }) => (
    <div className="submit-container">
      <Button
        type="submit"
        variant="contained"
        sx={{
          mt: 3,
          mb: 2,
          backgroundColor: "#ab1368",
          "&:hover": {
            backgroundColor: "#8d0e56",
          },
        }}
        onClick={onClick}
      >
        Confirm
      </Button>
    </div>
  );

  // Reusable dialog OK button component
  const DialogOKButton = ({ onClick }) => (
    <Button
      onClick={onClick}
      sx={{
        backgroundColor: "#ab1368",
        color: "white",
        "&:hover": {
          backgroundColor: "#8d0e56",
        },
      }}
    >
      OK
    </Button>
  );

  const displayRecordsData = useSelector((state) => state.displayRecords);
  const recordsSelected = displayRecordsData.selectedRecords;
  const rows = displayRecordsData.records;
  const inProgressColumns = displayRecordsData.retrievedColumnHeaders;
  const isLoading = displayRecordsData.isLoading;
  //const current_user = useSelector((state) => state.login.user);
  //const user_id = current_user.id;
  const {  isAuthorised } = useSelector((state) => state.authentication);
  const loginState = useSelector((state) => state.authentication)
   const user_id = loginState.user.userId;

  // Authorization is now handled at the route level in ChiesiRoutes
  const user_email = loginState.email;

  // Helper function to check if user is authorized for validate address
  const isUserAuthorizedForValidateAddress = () => [1, 15, 25, 38].includes(user_id);

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [dialogHeading, setDialogHeading] = useState("");
  const [dialogAction, setDialogAction] = useState(null);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [avConfirmationDialogOpen, setAvConfirmationDialogOpen] = useState(false);

  const [requestStatusDialogOpen, setRequestStatusDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    firstName: true,
    lastName: true,
    fullName: false,
    imcId: true,
    oneKeyId: true,
    onekeyMatched: false,
    onekeyValidationRequired: true,
    onekeyRequestId: false,
    onekeyStatus: true,
    title: false,
    wpName: true,
    address: true,
    address1: false,
    address2: false,
    city: true,
    state: true,
    postCode: true,
    specialty: true,
    email: false,
    fax: false,
    phone: true,
    notes: false,
    webcastWatched: false,
    chiesiRequestForm: false,
    contactPermission: false,
    jobId: true,
  });

  const [completedColumnVisibilityModel, setcompletedColumnVisibilityModel] =
    useState({
      id: false,
      jobId: false,
      fullName: false,
      onekeyRequestId: false,
      onekeyStatus: false,
      address1: false,
      address2: false,
      // email: false,
      // fax: false,
    });

  useEffect(() => {
    dispatch(clearRecords());
    dispatch(retrieveColumnsByJobId({ jobId: id }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error retrieving columns:', error);
      });
    dispatch(fetchRecords({ jobId: id }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error fetching records:', error);
      });
  }, [id, dispatch]);

  useEffect(() => {
    const selected = rows.filter((row) => recordsSelected.includes(row.id));
    setSelectedRecords(selected);
    console.log("Selected Records:", selected);
  }, [rows, recordsSelected]);

  const handleSendToOneKey = () => {
    setDialogAction(null);
    const recordsToSend = selectedRecords.filter(
      (record) =>
        (String(record.automatchRequired).toLowerCase() === "true" &&
        record.onekeyStatus !== "INPROCESS") 
        || ( record.status === "AutoMatchFailed" && String(record.automatchRequired).toLowerCase() === "false" && record.onekeyStatus === "QUOTA EXCEEDED")
    );

    if (recordsToSend.length > 0) {
      const alreadyMatched = recordsToSend.some(
        (record) => String(record.onekeyMatched).toLowerCase() === "true"
      );

      if (alreadyMatched) {
        setDialogHeading("Warning");
        setDialogContent("You have selected an already matched record.");
        setOpen(true);
      } else {
        const hasOneKeyRequestID = recordsToSend.some(
          (record) =>
            record.onekeyRequestId && record.onekeyRequestId.trim() !== ""
        );

        if (hasOneKeyRequestID) {
          setDialogHeading("Warning");
          setDialogContent(
            "Records with OneKey Request ID cannot be sent to OneKey."
          );
          setOpen(true);
        } else {
          setDialogHeading("Confirmation");
          setDialogContent(
            `Do you want to send the ${recordsToSend.length} selected record(s) with auto match required to OneKey?`
          );
          setDialogAction("sendToOneKey");
          setOpen(true);
        }
      }
    } else {
      setDialogHeading("Warning");
      setDialogContent(
        "No records with automatch required selected to send to OneKey!"
      );
      setOpen(true);
    }
  };

  const getOneKeyStatus = () => {
    setDialogAction(null);
    const recordsToProcess = selectedRecords.filter(
      (record) =>
        (String(record.manualmatchRequired).toLowerCase() === "true" &&
        record.status === "AutoMatchFailed" &&
        record.onekeyStatus !== "INPROCESS")
        || ( record.status === "ManualMatchFailed" && String(record.manualmatchRequired).toLowerCase() === "false" && record.onekeyStatus === "QUOTA EXCEEDED")

    );

    if (recordsToProcess.length > 0) {
      const alreadyMatched = recordsToProcess.some(
        (record) => String(record.onekeyMatched).toLowerCase() === "true"
      );

      if (alreadyMatched) {
        setDialogHeading("Warning");
        setDialogContent("You have selected an already matched record.");
        setOpen(true);
      } else {
        const missingOneKeyRequestID = recordsToProcess.some(
          (record) =>
            !record.onekeyRequestId || record.onekeyRequestId.trim() === ""
        );

        if (missingOneKeyRequestID) {
          setDialogHeading("Warning");
          setDialogContent(
            "Selected records require a pre-existing auto-match with status 'AutoMatchFailed'."
          );
          setOpen(true);
        } else {
          setDialogHeading("Confirmation");
          setDialogContent(
            `Do you want to send the ${recordsToProcess.length} selected record(s) for manual matching?`
          );
          setDialogAction("getValidationStatus");
          setOpen(true);
        }
      }
    } else {
      setDialogHeading("Warning");
      setDialogContent("No valid records selected to send for manual match!");
      setOpen(true);
    }
  };

  const completeJobs = () => {
    setDialogAction(null);
    setDialogHeading("Confirmation");
    setDialogContent("Do you want to mark the job as completed ?");
    setDialogAction("completeJob");
    setOpen(true);
  };
  const validateAddress = () => {
    if (!isUserAuthorizedForValidateAddress()) {
      setDialogHeading("Access Denied");
      setDialogContent("You are not authorized to perform address validation.");
      setOpen(true);
      return;
    }
    
    setDialogAction(null);
    setDialogHeading("Confirmation");
    setDialogContent("Do you want to validate the address ?");
    setDialogAction("ValidateAddress");
    setOpen(true);
  };
  const sendAllJobs = () => {
    const recordsToSend = rows.filter(
      (record) =>
        String(record.onekeyValidationRequired).toLowerCase() === "true"
    );

    if (recordsToSend.length > 0) {
      const alreadyMatchedRecord = recordsToSend.some(
        (record) => String(record.onekeyMatched).toLowerCase() === "true"
      );

      if (alreadyMatchedRecord) {
        setDialogHeading("Warning");
        setDialogContent("You are trying to send an already matched record");
        setOpen(true);
      } else {
        const hasOneKeyRequestID = recordsToSend.some(
          (record) =>
            record.onekeyRequestId && record.onekeyRequestId.trim() !== ""
        );

        if (hasOneKeyRequestID) {
          setDialogHeading("Warning");
          setDialogContent(
            "Records with OneKey Request ID cannot be sent to OneKey"
          );
          setOpen(true);
        } else {
          setDialogHeading("Confirmation");
          setDialogContent(
            "Do you want to send all the jobs marked as 'true' in HCA Validation Required to OneKey?"
          );
          setDialogAction("sendAllJobs");
          setOpen(true);
        }
      }
    } else {
      setDialogHeading("Warning");
      setDialogContent("No records to send to OneKey!");
      setOpen(true);
    }
  };

  const handleClickOpen = () => {
    handleSendToOneKey();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (dialogAction === "sendToOneKey") {
      setLoading(true);
      const recordsToSend = selectedRecords.filter(
        (record) =>
          (String(record.automatchRequired).toLowerCase() === "true" &&
          record.onekeyStatus !== "INPROCESS")
          || ( record.status === "AutoMatchFailed" && String(record.automatchRequired).toLowerCase() === "false" && record.onekeyStatus === "QUOTA EXCEEDED")
      );
      dispatch(
        sendOneKeyValidation({
          dataRecord: recordsToSend,
          jobId: id,
          userId: user_id,
          level: "tl2",
          userMail: user_email,
          //token: user_token,
        })
      )
        .then(() => {
          setLoading(false);
          setConfirmationDialogOpen(true);
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          if (error?.response?.status === 401) {
            // Session expired, redirect will be handled by global event listener
            return;
          }
          console.error('Error sending to OneKey:', error);
        });
    } else if (dialogAction === "completeJob") {
      setLoading(true);
      dispatch(completeJobsAPI({ jobId: id}))
        .catch((error) => {
          if (error?.response?.status === 401) {
            // Session expired, redirect will be handled by global event listener
            return;
          }
          console.error('Error completing job:', error);
        });
      setLoading(false);
      navigate("/custome-rmatch-portal/completedJobs");
    } else if (dialogAction === "getValidationStatus") {
      setLoading(true);
      const recordsToProcess = selectedRecords.filter(
        (record) =>
          (String(record.manualmatchRequired).toLowerCase() === "true" &&
          record.status === "AutoMatchFailed" &&
          record.onekeyStatus !== "INPROCESS")
          || ( record.status === "ManualMatchFailed" && String(record.manualmatchRequired).toLowerCase() === "false" && record.onekeyStatus === "QUOTA EXCEEDED")
      );
      dispatch(
        sendOneKeyValidation({
          dataRecord: recordsToProcess,
          jobId: id,
          userId: user_id,
          level: "tl2ex",
          userMail: user_email,
         // token: user_token,
        })
      )
        .then(() => {
          setLoading(false);
          setRequestStatusDialogOpen(true);
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          if (error?.response?.status === 401) {
            // Session expired, redirect will be handled by global event listener
            return;
          }
          console.error('Error getting validation status:', error);
        });
    }
    else if (dialogAction === "ValidateAddress") {
      setLoading(true);
      const recordsToValidate = selectedRecords.filter(
        (record) =>
          (String(record.validateAddress).toLowerCase() === "true" &&
          record.onekeyStatus !== "INPROCESS") || 
          ( record.status === "AutoMatchFailed" ) || 
          ( record.status === "ManualMatchFailed" )
      );
      
      dispatch(
        validateAddressApi({
          dataRecord: selectedRecords,
          jobId: id,
          userId: user_id,
          userMail: user_email,
         // token: user_token,
        })
      )
        .then(() => {
          setLoading(false);
          setAvConfirmationDialogOpen(true);
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          if (error?.response?.status === 401) {
            // Session expired, redirect will be handled by global event listener
            return;
          }
          console.error('Error validating address:', error);
        });
    }
    handleClose();
  };

  const handleConfirmationDialogClose = () => {
    setConfirmationDialogOpen(false);
    dispatch(fetchRecords({ jobId: id, token: user_token }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error refreshing records:', error);
      });
  };
  const handleAVConfirmationDialogClose = () => {
    setAvConfirmationDialogOpen(false);
    dispatch(fetchRecords({ jobId: id, token: user_token }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error refreshing records:', error);
      });
  };
  const handleRequestDialogClose = () => {
    setRequestStatusDialogOpen(false);
    dispatch(fetchRecords({ jobId: id, token: user_token }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error refreshing records:', error);
      });
  };

  const refreshRecords = () => {
    dispatch(fetchRecords({ jobId: id, token: user_token }))
      .catch((error) => {
        if (error?.response?.status === 401) {
          // Session expired, redirect will be handled by global event listener
          return;
        }
        console.error('Error refreshing records:', error);
      });
  };

  return (
    <>
      <div className="displayrecord-datagrid-container">
        {isLoading || !inProgressColumns ? (
          <div className="loading-container">
            <CircularProgress sx={{ color: "#ab1368" }} />
          </div>
        ) : IsInProgress ? (
          <RecordDisplayGrid
            rows={rows}
            columns={inProgressColumns}
            handleClickOpen={handleClickOpen}
            handleGetOneKeyStatus={getOneKeyStatus}
            handleRefreshRecords={refreshRecords}
            completeJob={completeJobs}
            validateAddress={validateAddress}
            sendAllJobs={sendAllJobs}
            columnVisibilityModel={columnVisibilityModel}
            setColumnVisibilityModel={setColumnVisibilityModel}
          />
        ) : (
          <CompletedRecordDisplayGrid
            rows={rows}
            columns={inProgressColumns}
            completedColumnVisibilityModel={completedColumnVisibilityModel}
            setcompletedColumnVisibilityModel={
              setcompletedColumnVisibilityModel
            }
          />
        )}
        <Dialog open={open} onClose={handleClose}>
          <DialogActions>
            <IconButton
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
          <DialogContent className="dialog-content">
            <h2 className="dialog-heading">{dialogHeading}</h2>
            <DialogContentText style={{ color: "#121212" }}>
              <p className="dialog-text">{dialogContent}</p>
            </DialogContentText>

            {dialogAction === "sendToOneKey" && (
              <>
                <ConfirmationButton onClick={handleConfirm} />
                <Typography
                  variant="caption"
                  color="#ff0f0f"
                  display="block"
                  gutterBottom
                  align="center"
                >
                  Note: Once the records have been sent to OneKey,
                  re-uploading is not allowed
                </Typography>
              </>
            )}
            {dialogAction === "completeJob" && (
              <ConfirmationButton onClick={handleConfirm} />
            )}
            {dialogAction === "getValidationStatus" && (
              <ConfirmationButton onClick={handleConfirm} />
            )}
            {dialogAction === "ValidateAddress" && (
              <ConfirmationButton onClick={handleConfirm} />
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={confirmationDialogOpen}
          onClose={handleConfirmationDialogClose}
        >
          <DialogContent>
            <DialogContentText>
              The selected record(s) are currently being processed by OneKey.
              This might take some time. You will receive an email once
              the auto-match is completed. To view the latest status, please
              click 'REFRESH'.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", padding: "5px" }}
          >
            <DialogOKButton onClick={handleConfirmationDialogClose} />
          </DialogActions>
        </Dialog>
        <Dialog
          open={avConfirmationDialogOpen}
          onClose={handleAVConfirmationDialogClose}
        >
          <DialogContent>
            <DialogContentText>
              The selected record(s) are currently being processed by OneKey.
              This might take some time. Address Validation is completed for selected records. To view the latest status, please
              click 'REFRESH'.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", padding: "5px" }}
          >
            <DialogOKButton onClick={handleAVConfirmationDialogClose} />
          </DialogActions>
        </Dialog>
        <Dialog
          open={requestStatusDialogOpen}
          onClose={handleRequestDialogClose}
        >
          <DialogContent>
            <DialogContentText>
              The selected record(s) are currently being processed by OneKey.
              This might take some time. You will receive an email once
              the manual-match is completed.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", padding: "5px" }}
          >
            <DialogOKButton onClick={handleRequestDialogClose} />
          </DialogActions>
        </Dialog>
        
        {/* Single loading overlay */}
        {loading && (
          <div className="loading-overlay">
            <CircularProgress sx={{ color: "#ab1368" }} />
          </div>
        )}
      </div>
    </>
  );
};

export default DisplayRecordsPage;
